import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Title,
  Text,
  Container,
  Box,
  Flex,
  Transition,
  useMantineTheme,
} from '@mantine/core';
import { useTimeout } from '@mantine/hooks';
import { HiOutlineArrowTopRightOnSquare } from 'react-icons/hi2';
import SpotifyButton from './SpotifyButton';
import { HeroBackground } from './HomePageBackground';
import TwizLogo from './TwizLogo';

const samplePDFUrl = 'https://music-bingo.s3.amazonaws.com/demo-hiphop-march2025.pdf';
const TRANSITION_DURATION = 200;

function HomePageHero(props) {
  const [ isMounted, setIsMounted ] = useState(false);
  const { start } = useTimeout(() => setIsMounted(true), TRANSITION_DURATION);

  const { colors } = useMantineTheme();
  const highlightColor = colors.violet[8];

  useEffect(() => {
    start();
  }, [isMounted])

  const {
    spotifyAuthUrl,
  } = props;

  const heroTransition = {
    in: { opacity: 1, transform: 'translateY(0)' },
    out: { opacity: 0, transform: 'translateY(24px)' },
    transitionProperty: 'transform, opacity',
  };


  return (
    <Box>
      <HeroBackground fixed>
        <Container px='xl' pt={{ base: 'xl', md: 56 }} pb={{ base: 80, md: 120 }} mih={{ base: 421, md: 380 }} style={{ overflow: 'hidden' }}>
          <Transition mounted={isMounted} transition='pop' duration={TRANSITION_DURATION} timingFunction='ease'>
            {(transitionStyle) => <TwizLogo width={48} height={48} style={transitionStyle} /> }
          </Transition>
          <Transition mounted={isMounted} transition={heroTransition} duration={TRANSITION_DURATION} timingFunction='ease-out'>
            {(transitionStyle) => 
            <Box>
              <Title order={1} mt='md' mb='xs' style={transitionStyle}>
                Music bingo games that make your brand <span style={{ color: highlightColor }}>shine</span>
              </Title>
              <Text color='gray.7' mb='xl' style={transitionStyle}>
                Customize game cards to promote your business & match the vibe of any playlist.
              </Text>
            </Box>}
          </Transition>

          <Transition mounted={isMounted} transition='pop-bottom-left' duration={TRANSITION_DURATION} timingFunction='ease-out'>
            {(transitionStyle) => 
            <Flex gap={{ base: 'sm', md: 'md' }} direction={{ base: 'column', sm: 'row' }} align='flex-start'>
              <SpotifyButton style={transitionStyle} href={spotifyAuthUrl} />
              <Button
                style={transitionStyle}
                component={Link}
                to={samplePDFUrl}
                target="_blank"
                variant='light'
                color='violet'
                size='md'
                leftIcon={<HiOutlineArrowTopRightOnSquare size={20} />}
              >
                View example
              </Button>
            </Flex>}
          </Transition>
        </Container>
      </HeroBackground>
    </Box>
  );
};

export default HomePageHero;

